import type { PersistApi } from '@sdk';

const ROOT = 'finlab.v1';

function readAll(): Record<string, unknown> {
  try {
    const raw = localStorage.getItem(ROOT);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export const persist: PersistApi = {
  load<T>(key: string, fallback: T): T {
    const all = readAll();
    return (all[key] as T) ?? fallback;
  },
  save(key: string, value: unknown) {
    const all = readAll();
    all[key] = value;
    localStorage.setItem(ROOT, JSON.stringify(all));
  },
};
